import React from "react";
import "./Progress.scss";
import { illustration, backgroundSection } from "../../portfolio";
import { motion } from "framer-motion";
import Coder from "../../assets/lottie/Coder";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";

export default function BackgroundSection() {
  if (!backgroundSection.display) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      {/* Rail wrapper (same idea as greet-main content-rail) */}
      <div className="background-section content-rail" id="background">
        {/* Inner grid (like .greeting-main) */}
        <div className="background-container-background">
          <div className="background-text">
            <h1 className="skills-heading">{backgroundSection.title}</h1>

            <p className="background-description">
              I am a Gameplay Programmer from Turkey with a background in C++ software engineering and real-time simulation. After working in R&D on V2X communication and autonomous vehicle testing systems, I transitioned into game development to pursue my passion for creating immersive multiplayer experiences. Over the past few years, I have designed and built <strong><a href="https://store.steampowered.com/app/3123610/Skyward_Steps_Together/" target="_blank" rel="noreferrer">Skyward Steps Together</a></strong>, a complete multiplayer co-op game developed in Unreal Engine 5. This project involved creating gameplay systems, multiplayer networking, UI, puzzle mechanics, and Steam integration from the ground up. I work across multiple development areas including gameplay system architecture, animation integration, optimization, and UI implementation, and I take pride in writing modular, scalable Blueprints and clean, maintainable C++ code. I am dedicated, self-motivated, and experienced in delivering polished, feature-rich gameplay experiences from concept to release.
            </p>
          </div>

          <div className="skills-image">
            {illustration.animated ? (
              <DisplayLottie animationData={Coder} />
            ) : (
              <img alt="Background" src={require("../../assets/images/skill.svg")} />
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
